/** Maps backend DocumentType enum values to human-readable labels. */
export const DOCUMENT_TYPE_LABELS = {
  APPEAL_FORM: "Appeal Form",
  DEPRECIATION_SCHEDULE: "Optimized Depreciation Schedule",
  COVER_PAGE: "Certified Cover Page",
  EVIDENCE_PACKET: "Full Evidence Packet",
};

export const getDocumentLabel = (type) => DOCUMENT_TYPE_LABELS[type] ?? type.replace(/_/g, " ");
